export const initialState = {
  categories: [],
  category: {},
  categoryTreeData: [],
  exerciseCategoryTreeData: [],
  educationMaterialCategoryTreeData: [],
  questionnaireCategoryTreeData: [],
  loading: false
};
